const t = {
  name: "LockSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 16V12H11V16H13Z" fill="currentColor"/>
<path d="M9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V8C16.6569 8 18 9.34315 18 11V17C18 18.6569 16.6569 20 15 20H9C7.34315 20 6 18.6569 6 17V11C6 9.34315 7.34315 8 9 8V7ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V8H13V7ZM8 11V17C8 17.5523 8.44772 18 9 18H15C15.5523 18 16 17.5523 16 17V11C16 10.4477 15.5523 10 15 10H9C8.44772 10 8 10.4477 8 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as LockSmall
};
